export const GET_TENANT = 'GET_TENANT';
export const TENANT_ERROR = 'TENANT_ERROR';
